export const IMAGEPATH = {
    // "logo": `${process.env.PUBLIC_URL}/assets/images/logo/ar247.svg`,
    logo: require('../assets/images/logo/ar247_s.png'),
    logoL: require('../assets/images/logo/ar247_l.png'),
    main: require('../assets/images/main.png'),
    robots1: require('../assets/images/robots/robots_1.png'),
    robots2: require('../assets/images/robots/robots_2.png'),
    solution: require('../assets/images/solution/solution.png'),
    b1: require('../assets/images/solution/b1.png'),
    b2: require('../assets/images/solution/b2.png'),
    b3: require('../assets/images/solution/b3.png'),
    machine: require('../assets/images/solution/image.jpeg'),
    map: require('../assets/images/solution/map.png'),
    baeromi: require('../assets/images/robots/robot_bae.jpg'),
    mini: require('../assets/images/robots/robot_mini.jpg'),
    seu: require('../assets/images/robots/robot_seu.jpg'),
    amr: require('../assets/images/robots/robot_amr.png'),
    amrE: require('../assets/images/robots/robot_amr_e.png'),
    fms1: require('../assets/images/solution/fms_1.png'),
    fms2: require('../assets/images/solution/fms_2.png'),
    fms3: require('../assets/images/solution/fms_3.png'),
    fms4: require('../assets/images/solution/fms_4.png'),
    //webp
    mainWebp: require('../assets/images_webp/main_70.webp'),
    robots1Webp: require('../assets/images_webp/robots/robots_1.webp'),
    robots2Webp: require('../assets/images_webp/robots/robots_2.webp'),
    solutionWebp: require('../assets/images_webp/solution/solution.webp'),
    b1Webp: require('../assets/images_webp/solution/b1.webp'),
    b2Webp: require('../assets/images_webp/solution/b2.webp'),
    b3Webp: require('../assets/images_webp/solution/b3.webp'),
    machineWebp: require('../assets/images_webp/solution/image.webp'),
    mapWebp: require('../assets/images_webp/solution/map.webp'),
    baeromiWebp: require('../assets/images_webp/robots/robot_bae.webp'),
    miniWebp: require('../assets/images_webp/robots/robot_mini.webp'),
    seuWebp: require('../assets/images_webp/robots/robot_seu.webp'),
    amrWebp: require('../assets/images_webp/robots/robot_amr.webp'),
    amrEWebp: require('../assets/images_webp/robots/robot_amr_e.webp'),
    fms1Webp: require('../assets/images_webp/solution/fms_1.webp'),
    fms2Webp: require('../assets/images_webp/solution/fms_2.webp'),
    fms3Webp: require('../assets/images_webp/solution/fms_3.webp'),
    fms4Webp: require('../assets/images_webp/solution/fms_4.webp'),
}



